import React, { Component } from "react";
import { Link } from "react-router-dom";
import mediaImage from "./../../../assets/images/user.jpg";
import TwitterIcon from "./../../../icons/twittericon";
import InstaIcon from "./../../../icons/instaicon";
import TextField from "./../../../component/TextField";
import FpgeeditIcon from "./../../../icons/fpgediticon";
import FpgDisableIcon from "./../../../icons/fpgdisableicon";
import FpgpublishIcon from "./../../../icons/fpgpublishicon";
import FpgDeleteIcon from "./../../../icons/fpgdeleteicon";
import ShowPassIcon from "../../../icons/ShowPassIcon";
import ViewIcon from "../../../icons/viewIcon";
import Slider from "react-slick";
//moment import
import moment from "moment";
//Service import
import service from "../../../services";
import ErrorPopUp from '../../errorPopUp';
import RecordPresenceBanner from "../../RecordPresenceBanner";

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'
import PopUpCustomAll from "../create/popUpCustomAll";
import Loader from "../../loader";
import CheckBox from "../../CheckBox";


let sub;

const mapStateToProps = state => ({
    partnerEventId: state.partnerEventId,
    filmEditId: state.filmEditId,
    recordViewers: state.recordViewers,
    recordConflict: state.recordConflict,
    getLoginAdminByID: state.getLoginAdminByID
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};


class PartnerEventsView extends Component {
    constructor() {
        super();
        this.state = {
            errorPopup: false,
            getAlldataFilm: [],
            loaderFlag: false,
            deleteFilm: false,
            publishFilm: false,
            disableFilm: false,
            hideFromLiveFilm: false,
            showFromLiveFilm: false,
            screencontent: false,
            artist: [],
        };
        this.apiserve = new service();
        this._hasLeftPresence = false;
    }

    componentDidMount() {
        this.props.ClearRecordPresence();
        {
            this.props.partnerEventId &&
                this.getAllNewFrontierdetails();
            this.getNewFrontierdetails();
        }
        this.setState({
            loaderFlag: true,
        });

        // RecordPresence: Join if recordId exists
        if (this.props.partnerEventId) {
            this.apiserve.sendevent("RecordPresence|join", {
                modelName: "partnerEvent",
                recordId: this.props.partnerEventId
            });
            // Add beforeunload handler
            this._handleBeforeUnload = () => {
                if (!this._hasLeftPresence) {
                    this._hasLeftPresence = true;
                    this.apiserve.sendevent("RecordPresence|leave", {
                        modelName: "partnerEvent",
                        recordId: this.props.partnerEventId
                    });
                }
            };
            window.addEventListener('beforeunload', this._handleBeforeUnload);
        }
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        if (this.props.partnerEventId && !this._hasLeftPresence) {
            this._hasLeftPresence = true;
            this.apiserve.sendevent("RecordPresence|leave", {
                modelName: "partnerEvent",
                recordId: this.props.partnerEventId
            });
        }
        if (this._handleBeforeUnload) {
            window.removeEventListener('beforeunload', this._handleBeforeUnload);
        }
        this.props.ClearRecordPresence();
    }

    closeAdminUser = () => {
        this.setState({
            deleteFilm: false,
            publishFilm: false,
            disableFilm: false,
            hideFromLiveFilm: false,
            showFromLiveFilm: false,
        })
    }

    getNewFrontierdetails = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "partnerEvents|getAllDetail":
                    if (!response.error) {
                        this.setState(
                            {
                                getAllNewFrontierdataFilm: response.data,
                                access: response.data.access && response.data.access.name,
                                mediaId: response.data.mediaId,
                                images: response.data.images,
                                contact: response.data.contact,
                                credits: response.data.credits,
                                artist: response.data.artist,
                                year: response.data.year,
                                category: response.data.category.name,
                                label: response.data.label,
                                language: response.data.language,
                                runTime: response.data.runTime,
                                company: response.data.company,
                                website: response.data.website,
                                accessibility: response.data.accessibility,
                                sponserName: response.data.sponserName,
                                description: response.data.description,
                                longDescription: response.data.longDescription,
                                dateTime: response.data.dateTime,
                                title: response.data.title,
                                status: response.data.status,
                                hideFromLive: response.data.hideFromLive,
                                categoryname: response.data.category.name,
                                URL: response.data.URL,
                                fileMakerId: response.data.fileMakerId,
                                // shift72Id: response.data.shift72Id,
                                dispalySchedule: response.data.dispalySchedule,
                                panelists: response.data.panelists,
                                ytLink:response.data.ytLink,
                            },
                            () => {
                                this.setState({
                                    loaderFlag: false,
                                });
                                this.props.setLastUpdated({
                                    updatedAt: response?.data?.updatedAt,
                                    updatedBy: {
                                        fname: response?.data?.updatedBy?.fname,
                                        lname: response?.data?.updatedBy?.lname
                                    }
                                })
                            }
                        );
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                case "partnerEvents|remove":
                    if (!response.error) {
                        this.props.history.push('/filmlist')
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                case "partnerEvents|updateStatus":
                    if (!response.error) {
                        this.setState({
                            hideFromLiveFilm: false,
                            disableFilm: false,
                            publishFilm: false,
                            showFromLiveFilm: false,
                          })
                          this.apiserve.success('Updated successfully')
                          this.apiserve.sendevent("partnerEvents|getAllDetail", { partnerEventId: this.props.partnerEventId });
                    }
                    else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                case "RecordPresence|viewersUpdate": {
                    if (!response.error && response?.data?.recordId === this.props.partnerEventId) {
                        const currentUserId = this.props.getLoginAdminByID;
                        const viewers = response?.data?.viewers || [];
                        const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
                        const currentUserHasMultipleSessions = currentUserSessionCount > 1;
                        const seenIds = new Set();
                        const filteredViewers = viewers
                            .filter(v => {
                                if (v?.userId === currentUserId) {
                                    return currentUserHasMultipleSessions;
                                }
                                return true;
                            })
                            .filter(v => {
                                if (seenIds.has(v?.userId)) return false;
                                seenIds.add(v?.userId);
                                return true;
                            })
                            .map(v => ({
                                userId: v?.userId,
                                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
                            }));
                        this.props.SetRecordViewers(filteredViewers);
                    }
                    break;
                }
            }
        });
    };

    getAllNewFrontierdetails = () => {
        var data = { partnerEventId: this.props.partnerEventId };
        this.apiserve.sendevent("partnerEvents|getAllDetail", data);
    };

    handelTwitter = (item) => {
        this.state.artist.forEach(element => {
            if (element._id === item._id) {
                window.open(item.twitter, "_blank");
            }
        });

    };

    handelInstagram = (item) => {
        this.state.artist.forEach(element => {
            if (element._id === item._id) {
                window.open(item.instagram, "_blank");
            }
        });

    };

    deleteFilm = () => {
        this.setState({
            deleteFilm: true
        })
    }

    deleteFilmPopupYes = () => {
        this.apiserve.sendevent("partnerEvents|remove", {
            partnerEventId: this.props.partnerEventId,
        });
    }

    publishFilm = () => {
        this.setState({
            publishFilm: true
        })
    }

    publishFilmPopupYes = () => {
        this.apiserve.sendevent("partnerEvents|updateStatus", {
            partnerEventId: this.props.partnerEventId,
            hideFromLive:this.state.hideFromLive,
            status: 1
        });
    }

    disableFilm = () => {
        this.setState({
            disableFilm: true
        })
    }

    disableFilmPopupYes = () => {
        this.apiserve.sendevent("partnerEvents|updateStatus", {
            partnerEventId: this.props.partnerEventId,
            hideFromLive:this.state.hideFromLive,
            status: 2
        });
    }

    hideFromLiveFilm = () => {
        this.setState({
          hideFromLiveFilm: true
        })
      }
    
      hideFromLiveFilmPopupYes = () => {
        this.apiserve.sendevent("partnerEvents|updateStatus", {
          partnerEventId: this.props.partnerEventId,
          status:this.state.status,
          hideFromLive: true
        });
      }
    
      showFromLiveFilm = () => {
        this.setState({
          showFromLiveFilm: true
        })
      }
    
      showFromLiveFilmPopupYes = () => {
        this.apiserve.sendevent("partnerEvents|updateStatus", {
          partnerEventId: this.props.partnerEventId,
          status:this.state.status,
          hideFromLive: false
        });
      }

    editNewFrontier = () => {
        this.props.CurrentTab(3)
        this.props.history.push({
            pathname: `/create-film/${this.props.partnerEventId}/edit`,
            callFrom: 3
        });
    };

    ScreenToggle = (e) => {
        var active = e.target.parentNode.closest(".inner_screen").querySelector(".screen_header").classList.toggle("active");
        var parentactive = e.target.closest(".screen_header").parentNode.parentNode.classList.toggle("active");
        var panel = e.target.parentNode.closest(".inner_screen").querySelector(".screen_content_outer");
        if (panel && panel.style.maxHeight) {
            panel.style.maxHeight = "";
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
        this.setState({
            screencontent: !this.state.screencontent
        })
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }
    render() {
        var settings = {
            customPaging: function (i) {
                return <a>{i + 1}</a>;
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        const activeViewers = this.props.recordViewers || [];
        return (
            <>
                <RecordPresenceBanner activeViewers={activeViewers} conflict={null} />
                <div className="fpg_tabcontent d_flex">
                <>
                <div className="tab_col left_col">
                    <div className="d_flex id_media d_flex_align_center">
                        <span className="id_text">
                            <label>Media ID:</label> {this.state.mediaId}
                            <label>Filemaker ID:</label> {this.state.fileMakerId}
                            {/* <label>Shift72 ID:</label> {this.state.shift72Id} */}
                        </span>
                    </div>
                    <Slider {...settings}>
                        {this.state.images &&
                            this.state.images.map((item) => (
                                <div>
                                    <div className="media_image">
                                        <img
                                            src={
                                                item.inSite ? this.apiserve.imageUrl + item.inSite :
                                                    item.link ? item.link :
                                                        '/images/image-placeholder.png'
                                            }
                                            alt="image"
                                        />
                                    </div>
                                </div>
                            ))}
                    </Slider>
                    {/* <div className="credit_section mt_15">
                            <div className="credit_header">
                                <h5>Credits</h5>
                            </div>
                            <div className="credit_content">
                                <ul>
                                    <li className="d_flex">
                                        {this.state.credits &&
                                            this.state.credits.map((item) => (
                                                <>
                                                    <label>{item && item.creditId && item.creditId.name}</label>
                                                    <span className="name">
                                                        {item.creditType &&
                                                            item.creditType.map((creditTypeName) => (
                                                                <p>{creditTypeName.creditsInsideType}</p>
                                                            ))}
                                                    </span>
                                                </>
                                            ))}
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                    <div className="credit_section artist_section">
                        <div className="credit_header">
                            <h5>Panelist</h5>
                        </div>
                        <div className="artist_content">
                            {this.state.panelists ?.map((item) => {
                                return (
                                    <>
                                    <div className="d_flex inner_artist mb_15">

                                        <div className="artist_user">
                                            <img
                                                src={
                                                    item.image
                                                        ? this.apiserve.imageUrl + item.image
                                                        : '/images/user.png'
                                                }
                                                alt="user"
                                            />
                                        </div>
                                        <div className="artist_data">
                                            <div className="d_flex user_name">
                                                <h4>{item.name}</h4>
                                                <div className="d_flex d_flex_align_center">
                                                    {item.twitter &&
                                                        <Link
                                                            className="d_flex d_flex_align_center"
                                                            onClick={() => this.handelTwitter(item)}
                                                        >
                                                            <TwitterIcon />
                                                        </Link>
                                                    }
                                                    {item.instagram &&
                                                        <Link
                                                            className="d_flex d_flex_align_center"
                                                            onClick={() => this.handelInstagram(item)}
                                                        >
                                                            <InstaIcon />
                                                        </Link>
                                                    }
                                                </div>
                                            </div>
                                            <div className="user_desc">

                                                <div className="editor_view p_0" dangerouslySetInnerHTML={{ __html: item.description }} ></div>

                                            </div>
                                            {/* <div className="video_wrap">
                                                        <iframe src={item.youtube}></iframe>
                                                    </div> */}
                                        </div>
                                    </div>
                                    </>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="tab_col feature_col" style={{maxWidth:`calc(100% - 430px)`}}>
                    <div className="fpg_edits_links d_flex d_flex_align_center">
                        <Link className="d_flex d_flex_align_center d_flex_justify_center"
                            onClick={this.editNewFrontier}
                        >
                            <FpgeeditIcon />
                            EDIT
                            </Link>
                        {this.state.status === 1 ?
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.disableFilm()}>
                                <FpgDisableIcon /> DISABLE
                                </Link>
                            :
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.publishFilm()}>
                                <FpgpublishIcon /> PUBLISH
                                </Link>
                        }
                        {this.state.hideFromLive === true ?
                            <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.hideFromLiveFilm()}>
                                <ViewIcon /> Show On Live
                            </Link>
                            :
                            <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.showFromLiveFilm()}>
                                <ShowPassIcon /> Hide From Live
                            </Link>
                        }
                        <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deleteFilm()}>
                            <FpgDeleteIcon />
                            DELETE
                            </Link>
                    </div>
                    {/* <div className="id_text mt_5 mb_10">
                            <li className="d_flex">
                                <label>Access: </label>
                                <span>&nbsp;{this.state.access}</span>
                            </li>
                        </div> */}
                    <p className="feature_text">Partner Events</p>
                    <div className="feature_title">
                        <h3>{this.state.title}</h3>
                        {/* <div className="field_row mb_25">
                                <div className="editor_view" dangerouslySetInnerHTML={{ __html: this.state.description }} />
                            </div> */}
                        <div className="field_row mb_25">
                            <label className="font_600"> Short Description</label>
                            <div className="editor_view" dangerouslySetInnerHTML={{ __html: this.state.description }} />
                        </div>
                        <div className="field_row mb_25">
                            <label className="font_600"> Long Description</label>
                            <div className="editor_view" dangerouslySetInnerHTML={{ __html: this.state.longDescription }} />
                        </div>
                    </div>
                    <div className="data_list">
                        <ul>
                            {/* <li className="d_flex">
                                    <label>Year</label>
                                    <span>{this.state.year}</span>
                                </li> */}
                            <li className="d_flex">
                                <label>Label</label>
                                <span>{this.state.label}</span>
                            </li>
                            <li className="d_flex">
                                <label>Category</label>
                                <span>{this.state.category}</span>
                            </li>
                        </ul>
                        <ul>
                            <li className="d_flex">
                                <label>Accessibility</label>
                                <span>
                                    {this.state.accessibility &&
                                        this.state.accessibility.map((item) => (
                                            <p>{item.name}</p>
                                        ))}
                                </span>
                            </li>
                            <li className="d_flex ">
                                <label>Sponsor Name</label>
                                <span>
                                    {this.state.sponserName}
                                </span>
                            </li>
                            <li className="field_row_inner right_check">
                                <div className="checkbox_field_row">
                                    <div className="checkBox">
                                        <input
                                            type="checkbox"
                                            id="schedule"
                                            name="schedule"
                                            checked={this.state.dispalySchedule}
                                            // disabled={true}
                                            // value={value}
                                            onChange={(e) => this.props.onChange(e)} />
                                        <label for="schedule" style={{ width: "135px" }}>Display in Schedule? </label>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="screen_dates" style={{ maxWidth: "700px" }}>
                        <div className="header_title">
                            <h3><label>Event Start Date & Time (MT)</label> - <label>Event End Date & Time (MT)</label><label>Location</label><label>Waitlist Slots</label> <label>Accessibility</label></h3>
                        </div>
                        <div className="screen_list">
                            <ul>

                                {
                                    this.state.dateTime && this.state.dateTime.length >= 1 ?
                                        this.state.dateTime.map((item) => {
                                            var fpgFlimViewStart = new Date(item.date);
                                            var fpgFlimViewEnd = new Date(item.endDate);
                                            return (
                                                <li className="disp_flex">
                                                    {/* <label>{moment(fpgFlimViewStart).tz("US/Mountain").format('MMM DD')}</label>
                                                    <span className="time_text time_text_nf">
                                                        {moment(fpgFlimViewStart).tz("US/Mountain").format('h:mm A')} - {moment(fpgFlimViewEnd).tz("US/Mountain").format('h:mm A')}
                                                    </span> */}
                                                    <span className="time_text time_text_nf">
                                                        {moment(fpgFlimViewStart).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewStart).tz("US/Mountain").format('h:mm A')}  -  {moment(fpgFlimViewEnd).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewEnd).tz("US/Mountain").format('h:mm A')}
                                                    </span>
                                                    <p className="d_flex">

                                                        {
                                                            item ?.locationType === undefined || item.locationType === "2" ? <span className="d_block"> Online </span> :
                                                                item ?.locations.length > 0 ? item ?.locations.map((loc) => {
                                                                    return <span className="d_block"> {loc ?.name} &nbsp;</span>
                                                                }) : ''
                                                            }

                                                    </p>
                                                    <p className="d_flex"><span className="d_block pl_25">{(item?.maxWaitListSlots === 0 && item?.locationType === "1") ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : item?.maxWaitListSlots}</span></p>
                                                    <p className="d_flex waitlist_slot">{item?.accessibility.length > 0 ? item?.accessibility[0]?.name : '-'} {item?.accessibility.length > 1 && <>
                                                        <span>+ More</span>
                                                        <div className="tooltip_box">{item?.accessibility.map((acc, i) => {return (<span>{acc?.name}</span>)}) }</div>
                                                    </>}</p>
                                                </li>
                                            )
                                        }) : ''
                                }

                            </ul>
                        </div>
                    </div>
                    {this.state.URL &&
                        <div className="data_list">
                            <ul>
                                <li className="d_flex">
                                    <label>Event Link</label>
                                    <span>{this.state.URL}</span>
                                </li>
                            </ul>
                        </div>
                    }
                    {
                        this.state.ytLink !== '' ?

                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label>YT Event Link</label>
                                        <span>{this.state.ytLink}</span>
                                    </li>
                                </ul>
                            </div> 
                            : ''
                    }
                </div>
                </>
                {/* ))} */}
                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }
                {this.state.deleteFilm ?
                    <PopUpCustomAll
                        HeaderName='Delete?'
                        insideDetails='You are about to delete an item and this action is permanent'
                        insideData='Do you want to proceed?'
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteFilmPopupYes}
                    />
                    : ''}

                {this.state.publishFilm ?
                    <PopUpCustomAll
                        HeaderName='Publish Changes'
                        insideDetails='Saving the current changes will publish it to the production site'
                        insideData='Do you want to proceed?'
                        popupState={this.closeAdminUser}
                        yesPopUp={this.publishFilmPopupYes}
                    />
                    : ''}
                {this.state.hideFromLiveFilm ?
                    <PopUpCustomAll
                    HeaderName='Show On Live?'
                    insideDetails='Saving the current changes will show it to the site'
                    insideData='Do you want to proceed?'
                    popupState={this.closeAdminUser}
                    yesPopUp={this.showFromLiveFilmPopupYes}
                    />
                    : ''
                }
                {this.state.showFromLiveFilm ?
                    <PopUpCustomAll
                    HeaderName='Hide From Live'
                    insideDetails='Saving the current changes will hide it from the site'
                    insideData='Do you want to proceed?'
                    popupState={this.closeAdminUser}
                    yesPopUp={this.hideFromLiveFilmPopupYes}
                    />
                    : ''
                }
                {this.state.disableFilm ?
                    <PopUpCustomAll
                        HeaderName='Disable?'
                        insideDetails='You are about to disable an item, which will temporarily make it unavailable on the production site'
                        insideData='Do you want to proceed?'
                        popupState={this.closeAdminUser}
                        yesPopUp={this.disableFilmPopupYes}
                    />
                    : ''}
                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}
            </div>
            </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerEventsView)